export const DISCOUNTS_RESET_STATE = 'DISCOUNTS_RESET_STATE';
export const DISCOUNTS_CURRENT_ITEM = 'DISCOUNTS_CURRENT_ITEM';

export const DISCOUNTS_REQUEST_LOADING = 'DISCOUNTS_REQUEST_LOADING';
export const DISCOUNTS_REQUEST_SUCCESS = 'DISCOUNTS_REQUEST_SUCCESS';
export const DISCOUNTS_REQUEST_FAILED = 'DISCOUNTS_REQUEST_FAILED';

export const DISCOUNTS_CURRENT_ACTION = 'DISCOUNTS_CURRENT_ACTION';
export const DISCOUNTS_RESET_ACTION = 'DISCOUNTS_RESET_ACTION';